import "./utils/disableConsoleLogs";
import DynamicFavicon from "./components/shared/DynamicFavicon";
import { Routes, Route, Navigate } from "react-router-dom";
import GTMInjector from "./components/GTMInjector";
import { PageViewTracker } from "./components/analytics/PageViewTracker";
import { PublicLayout } from "./components/layout/PublicLayout";
import AuthInitializer from "./components/auth/AuthInitializer";
import URLParamsProvider from "./providers/URLParamsProvider";
import IDXRoute from "./components/auth/IDXRoute";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { TenantConfig } from "./types/tenant";

import DashboardPage from "./pages/DashboardPage";
import Search from "./pages/SearchPage";
import Auth from "./pages/AuthPage";
import LandingPage from "./pages/LandingPage";
import TeamMemberPage from "./pages/TeamMemberPage";
import PropertyDetail from "./pages/PropertyDetail";
import PropertyValuation from "./pages/ValuationPage";
import DebugValuation from "./pages/DebugValuationPage";
import ValuationLanding from "./pages/ValuationLandingPage";
import DynamicLandingPage from "./pages/DynamicLandingPage";
import AdLandingPage from "./pages/AdLandingPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import DMCAPage from "./pages/DMCAPage";
import NotFoundPage from "./pages/NotFoundPage";

interface AppProps {
  tenantConfig: TenantConfig | null;
}

function App() {
  return (
    <>
      <DynamicFavicon />
      <URLParamsProvider>
        <AuthInitializer>
          <GTMInjector />
          <PageViewTracker />
          <Routes>
            {/* Redirect root to landing page */}
            <Route path="/" element={<Navigate to="/home" replace />} />

            {/* Public routes */}
            <Route element={<PublicLayout />}>
              <Route
                path="/home"
                element={
                  <IDXRoute>
                    <LandingPage />
                  </IDXRoute>
                }
              />
              <Route
                path="/search"
                element={
                  <IDXRoute>
                    <Search />
                  </IDXRoute>
                }
              />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/dmca" element={<DMCAPage />} />
              <Route
                path="/team/:slugOrFirstName"
                element={
                  <IDXRoute>
                    <TeamMemberPage />
                  </IDXRoute>
                }
              />
              <Route
                path="/property/:listingKey"
                element={
                  <IDXRoute>
                    <PropertyDetail />
                  </IDXRoute>
                }
              />
              <Route path="/valuation" element={<ValuationLanding />} />

              <Route
                path="/property/:listingId/valuation"
                element={<PropertyValuation />}
              />
              <Route
                path="/property/:listingId/debug-valuation"
                element={<DebugValuation />}
              />
              <Route path="/auth/*" element={<Auth />} />
              {/* Dynamic Landing Pages */}
              <Route
                path="/:citySlug/:featureSlug"
                element={
                  <IDXRoute>
                    <DynamicLandingPage />
                  </IDXRoute>
                }
              />
              {/* Ad Landing Page with URL parameters */}
              <Route
                path="/lp"
                element={
                  <IDXRoute>
                    <AdLandingPage />
                  </IDXRoute>
                }
              />
            </Route>

            {/* Protected Dashboard Routes */}
            <Route element={<PublicLayout />}>
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* 404 Page - Catch all unmatched routes */}
            <Route element={<PublicLayout />}>
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </AuthInitializer>
      </URLParamsProvider>
    </>
  );
}

export default App;
